module.exports = __webpack_public_path__ + "static/media/forward-white.7fb337de.svg";